export default "__VITE_ASSET__duvBGFsX__"